import React, { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check for existing session on app load
  useEffect(() => {
    const checkExistingSession = () => {
      const sessionId = localStorage.getItem("ai_agent_session_id");
      const email = localStorage.getItem("ai_agent_user_email");
      const name = localStorage.getItem("ai_agent_user_name");

      if (sessionId && email) {
        setUser({
          email: email,
          name: name || email.split("@")[0],
          sessionId: sessionId,
        });
      }
      setIsLoading(false);
    };

    checkExistingSession();
  }, []);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    // Clear localStorage
    localStorage.removeItem("ai_agent_session_id");
    localStorage.removeItem("ai_agent_user_email");
    localStorage.removeItem("ai_agent_user_name");

    // Reset Chatwoot session
    if (window.$chatwoot) {
      window.$chatwoot.reset();
    }

    setUser(null);
  };

  const value = {
    user,
    isAuthenticated: !!user,
    isLoading,
    login,
    logout,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
